import { render } from "./ProfilePage.vue?vue&type=template&id=717dde7a&ts=true"
import script from "./ProfilePage.vue?vue&type=script&lang=ts"
export * from "./ProfilePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Profile/ProfilePage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "717dde7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('717dde7a', __exports__)) {
    api.reload('717dde7a', __exports__)
  }
  
  module.hot.accept("./ProfilePage.vue?vue&type=template&id=717dde7a&ts=true", () => {
    api.rerender('717dde7a', render)
  })

}


export default __exports__